import React, { useState } from 'react';
import { LinearProgress } from '@mui/material';
import { SettingType } from '../../../../api/vault/publishEndpoints';
import { IProps } from './interfaces';
import {
  SocialDialog,
  SocialDialogHeader,
  SocialDialogTitle,
  SocialDialogActions,
  WhatIsHappeningField,
} from '../../../Shared/Publish/SocialDialog';
import { DialogContentContainer } from '../../../Shared/styles/dialog';
import { ProgressContainer } from '../../../Shared/JobList/styles';

const TwitterPublishDialog: React.FunctionComponent<IProps> = (props: IProps) => {
  const { onPublish } = props;

  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <SocialDialog settingType={SettingType.Twitter}>
      <SocialDialogHeader>
        <SocialDialogTitle />
      </SocialDialogHeader>
      <ProgressContainer>
        {isProcessing && <LinearProgress />}
      </ProgressContainer>
      <DialogContentContainer>
        <WhatIsHappeningField />
      </DialogContentContainer>
      <SocialDialogActions onPublish={onPublish} setIsProcessing={setIsProcessing} isProcessing={isProcessing} />
    </SocialDialog>
  );
};

export default TwitterPublishDialog;
